import { useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "./routes";
import { useDispatch } from "react-redux";
import { setMinMaxOptions } from "@redux/slices/searchFilters";

export const useGetMinMaxOptions = (
  enabled: boolean,
  id: number,
  setEnabled?: any
) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["MIN_MAX_OPTIONS", id],
    enabled: enabled,
    queryFn: () =>
      apiClient
        .get(Routes.MIN_MAX_OPTIONS(id), {
          headers: {
            ...apiClient.defaults.headers.common,
            "If-None-Match": "",
          },
        })
        .then((response) => {
          setEnabled(false);
          const data = response?.data?.response?.body ?? {};
          dispatch(setMinMaxOptions(data));
          return data;
        }),
  });
};
